import {createActionCreators, ImmerReducer} from 'immer-reducer'
import {Status} from 'commonTypes'
import {select_gridSession} from 'redux/totals/selectors'
import {FiltersType} from 'redux/totals/state'
import defaultTotalsState, {TotalsStateType} from './state'
import {TabType} from 'router/settings'
import {getTabCounts, getHomeStats} from 'api/graphQL/queries/common.queries'
import {genericRequestError} from 'redux/toast/toast.duck'
import {normalizeForTotalsApi} from 'helpers/jobs'
import {Query} from 'graphql-api'

class Totals extends ImmerReducer<TotalsStateType> {
  showFiltersToggled() {
    this.draftState.showFilters = !this.state.showFilters
  }
  fetchTotalsGO() {
    this.draftState.status = Status.PENDING
  }
  fetchTotalsOK(tabs: any) {
    this.draftState.status = Status.OK
    this.draftState.tabs = tabs
  }
  fetchTotalsERR(error) {
    this.draftState.error = error
    this.draftState.status = Status.REJECTED
  }
  fetchHomeStatsGO() {
    this.draftState.status = Status.PENDING
  }
  fetchHomeStatsOK(homeStats: Query) {
    this.draftState.status = Status.OK
    this.draftState.homeStats = homeStats
  }
  fetchHomeStatsERR(error) {
    this.draftState.error = error
    this.draftState.status = Status.REJECTED
  }
  homeStatsReset() {
    this.draftState.homeStats = defaultTotalsState.homeStats
  }
  filtersApplied(filters: FiltersType) {
    this.draftState.gridSession.filters = filters
  }
  hydrateApplied(hydrate: boolean) {
    this.draftState.hydrate = hydrate
  }
}

export const fetchTotals = () => async function(dispatch) {
  dispatch(TotalsAC.fetchTotalsGO())
  try {
    const {data} = await getTabCounts()

    const tabs = {
      [TabType.databases]: data.databases?.length ?? 0,
      [TabType.jobs]: data.jobs?.totalCount ?? 0,
      [TabType.jobRequests]: data.jobRequests?.totalCount ?? 0,
    }
    dispatch(TotalsAC.fetchTotalsOK(tabs))
  } catch (err) {
    dispatch(genericRequestError())
    dispatch(TotalsAC.fetchTotalsERR(JSON.parse(JSON.stringify(err))))
  }
}

export const fetchHomeStats = () => async function(dispatch, getState) {
  const gridSession = select_gridSession(getState())
  const {filters} = normalizeForTotalsApi(gridSession)

  dispatch(TotalsAC.fetchHomeStatsGO())
  try {
    const {data} = await getHomeStats(filters)
    dispatch(TotalsAC.fetchHomeStatsOK(data))
    dispatch(TotalsAC.hydrateApplied(true))
  } catch (err) {
    dispatch(genericRequestError())
    dispatch(TotalsAC.fetchHomeStatsERR(JSON.parse(JSON.stringify(err))))
  }
}

export const refreshHomeStats = (
  routerInstance,
  filters?: FiltersType
) => async function(dispatch, getState) {
  const gridSession = select_gridSession(getState())

  const {
    globals: {params: stateParams, current: {name: stateName}},
    stateService,
  } = routerInstance

  if(filters){
    dispatch(TotalsAC.filtersApplied(filters))
  }

  await stateService.go(stateName, {
    ...stateParams,
    filters: filters ?? gridSession.filters,
  })
}

export const TotalsAC = createActionCreators(Totals)

export default Totals
